import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BrokenMedia = ({ className = '', style }) => (
  <div
    className={`broken-media d-flex align-items-center justify-content-center bg-neutral ${className}`}
    style={style}
  >
    <span className="fa-layers text-white" style={{ fontSize: 'clamp(1rem, 25cqmin, 3rem)' }}>
      <FontAwesomeIcon icon={["fas", "photo-film"]} />
      <FontAwesomeIcon icon={["fas", "slash"]} />
    </span>
  </div>
);

export default BrokenMedia;
